// extracted by mini-css-extract-plugin
export default {"cls1":"StyledComponents-PromptContainer_cls1__NA70Y","cls2":"StyledComponents-PromptContainer_cls2__zhw-o StyledComponents-PromptContainer_cls1__NA70Y"};